msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-28 15:56+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: it\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:11
msgid "safeSend.tabs.header.dbName"
msgstr "Nome"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:16
msgid "safeSend.tabs.header.emails"
msgstr "Indirizzi email esclusi"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:23
msgid "safeSend.tabs.header.actions"
msgstr "Azioni sospette"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:30
msgid "safeSend.tabs.header.status"
msgstr "Stato"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/NewFeatureBanner/index.tsx:8
msgid "features.newFeatureBanner.safesend"
msgstr "<bold>⭐️ Novità:</bold> SafeSend, il filtro per gli indirizzi email pericolosi"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:73
msgid "features.footer.followEmailTrainingLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/formations-email-delivrabilite-deduplication-et-reactivation-des-inactifs/"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:85
msgid "features.footer.learnMoreLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/audits-conseils-gestion-emailing/"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:36
msgid "dashboards.menuCards.deliverability.content"
msgstr "Vista globale della tua deliverability su tutti i database"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:38
msgid "dashboards.menuCards.deliverability.title"
msgstr "Report di deliverability"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:43
msgid "dashboards.menuCards.campaign.content"
msgstr "Analizza le prestazioni di campagne e segmenti su ogni database"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:45
msgid "dashboards.menuCards.campaign.title"
msgstr "Statistiche delle campagne"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:59
msgid "dashboards.title"
msgstr "Benvenuto in Mindbaz Dashboards!"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:60
msgid "dashboards.description"
msgstr "Monitora la deliverability e le prestazioni delle campagne sui tuoi database Mindbaz. Con la nostra dashboard \"Report di deliverability\", puoi tenere d'occhio la deliverability e la reputazione dei tuoi domini e indirizzi IP presso gli ISP. Analizza le prestazioni delle campagne nel loro insieme o per segmento con la nostra dashboard \"Statistiche delle campagne\"."

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:75
msgid "dashboards.customDashboards"
msgstr "Dashboard personalizzate"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:105
msgid "dashboards.needCustomDashboard"
msgstr "Hai bisogno di una dashboard personalizzata?"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:99
msgid "snapshot.gridPerformances.header.sentRate"
msgstr "Tasso di invio"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:106
msgid "snapshot.gridPerformances.header.deliveredEmails"
msgstr "Email recapitate"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:113
msgid "snapshot.gridPerformances.header.hardBounce"
msgstr "Hard Bounce"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:121
msgid "snapshot.gridPerformances.header.openers"
msgstr "Aperture"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:128
msgid "snapshot.gridPerformances.header.clickers"
msgstr "Clic"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:135
msgid "snapshot.gridPerformances.header.unsubscribes"
msgstr "Disiscrizioni"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:145
msgid "table.labelRowsPerPage"
msgstr "Risultati per pagina:"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:147
msgid "table.labelDisplayedRowsSeparator"
msgstr "di"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:150
msgid "table.labelNoRows"
msgstr "Spiacenti, nessun risultato corrisponde alla tua ricerca"

#. js-lingui-explicit-id
#: src/pages/DailyReport/TabInformations/index.tsx:46
msgid "snapshot.databases"
msgstr "Database"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:130
msgid "safesend.dailyStats.excludedEmails"
msgstr "Indirizzi email esclusi"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:134
msgid "safesend.dailyStats.suspiciousActions"
msgstr "Azioni sospette"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:156
#: src/pages/SafeSend/index.tsx:174
msgid "safesend.databaseStats.fromDate"
msgstr "Attivato dal {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:165
msgid "safesend.databaseStats.untilDate"
msgstr "Attivato fino al {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:186
msgid "safesend.databaseStats.dateRange"
msgstr "Dal {startDate} al {endDate}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:194
msgid "safesend.cards.emails.title"
msgstr "Indirizzi email esclusi"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:195
msgid "safesend.cards.emails.description"
msgstr "{data} indirizzi email sono stati esclusi dai tuoi invii."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:204
msgid "safesend.cards.actions.title"
msgstr "Azioni sospette"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:205
msgid "safesend.cards.actions.description"
msgstr "Le azioni di {data} indirizzi email sospetti sono state limitate nelle tue statistiche."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:235
msgid "table.search"
msgstr "Cerca"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:236
msgid "table.elementsTabCount"
msgstr "elementi nella mia pagina"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:245
msgid "safesend.title"
msgstr "SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:246
msgid "safesend.description"
msgstr "Monitora il numero di indirizzi email esclusi dai tuoi invii e le cui azioni sono limitate nelle tue statistiche grazie a SafeSend. Per saperne di più su SafeSend, "

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:248
msgid "safesend.descriptionLink"
msgstr "https://serviceclient.mindbaz.com/en/faq/safesend-le-filtre-%C3%A0-emails-dangereux-par-mindbaz"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:257
msgid "safesend.panel.title"
msgstr "Scelta del periodo"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:258
msgid "safesend.panel.period"
msgstr "Periodo"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:341
msgid "safesend.popup.title"
msgstr "Scelta del periodo"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:346
msgid "safesend.popup.description"
msgstr "Per modificare l'offerta SafeSend, contatta un amministratore: {adminList}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:107
msgid "snapshot.tabs.general.title"
msgstr "Generale"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:120
msgid "snapshot.tabs.performance.title"
msgstr "Prestazioni per database"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:152
msgid "snapshot.title"
msgstr "Benvenuto nella tua istantanea di deliverability!"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:153
msgid "snapshot.description"
msgstr "Consulta le tue statistiche email per <strong>{values}</strong>. Nella <strong>scheda Generale</strong>, troverai gli avvisi di deliverability attivi in questa data e le prestazioni dei tuoi database. Se desideri una vista dettagliata per database, usa la <strong>scheda Prestazioni per database</strong>."

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:158
msgid "snapshot.displayStatistics"
msgstr "Mostra le statistiche del"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:172
msgid "snapshot.switch_apple_mpp.label"
msgstr "Includi"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:176
msgid "snapshot.switch_apple_mpp.link"
msgstr "https://serviceclient.mindbaz.com/en/faq/apple-mail-privacy-protection-mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:178
msgid "snapshot.switch_apple_mpp.linkText"
msgstr "Apple MPP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:180
msgid "snapshot.switch_apple_mpp.endLabel"
msgstr "aperture"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:5
msgid "features.cards.safesend.title"
msgstr "Filtra automaticamente le email pericolose"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:6
msgid "features.cards.safesend.description"
msgstr "SafeSend è il filtro Mindbaz che rimuove automaticamente gli indirizzi email pericolosi dai tuoi invii."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:7
msgid "features.cards.safesend.bafflingProblem"
msgstr "Le tue campagne email sono influenzate da bot, reclami spam, spam trap ed email usa e getta, che riducono il tuo tasso di deliverability e la tua reputazione presso gli ISP."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:8
msgid "features.cards.safesend.goal"
msgstr "Invia le tue campagne solo agli indirizzi giusti e ottimizza la tua deliverability senza sforzo."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:9
msgid "features.cards.safesend.activateFeature"
msgstr "Attiva SafeSend"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:12
msgid "features.cards.dashboards.title"
msgstr "Visualizza le prestazioni di tutti i tuoi database con una vista globale"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:13
msgid "features.cards.dashboards.description"
msgstr "Con Dashboards, non hai più bisogno di uscire dalla tua piattaforma di invio per analizzare tutte le tue campagne."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:14
msgid "features.cards.dashboards.bafflingProblem"
msgstr "Per inviare campagne email di massa, la maggior parte dei nostri clienti utilizza database diversi. Quando la stessa campagna email viene inviata a più database, come stimi le prestazioni complessive della campagna presso i provider di posta?"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:15
msgid "features.cards.dashboards.goal"
msgstr "Utilizza uno strumento di visualizzazione dati multi-database."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:16
msgid "features.cards.dashboards.activateFeature"
msgstr "Prova gratuita di 30 giorni"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:19
msgid "features.cards.snapshot.title"
msgstr "Ottieni un'istantanea quotidiana della tua deliverability"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:20
msgid "features.cards.snapshot.description"
msgstr "Snapshot ti permette di anticipare i problemi di deliverability per risolverli rapidamente."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:21
msgid "features.cards.snapshot.bafflingProblem"
msgstr "Le agenzie che inviano campagne email di massa possono essere soggette a rischi di deliverability e a cambiamenti nelle best practice. Se controlli ogni campagna individualmente per cercare di capire il motivo di un calo di deliverability, è una perdita di tempo."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:22
msgid "features.cards.snapshot.goal"
msgstr "Risparmia tempo nell'analisi della tua deliverability presso i provider di posta approfittando di un'istantanea quotidiana della tua deliverability."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:23
msgid "features.cards.snapshot.activateFeature"
msgstr "Prova gratuita di 30 giorni"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:28
msgid "safesend.panel.thirtyLastDays"
msgstr "Ultimi 30 giorni"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:29
msgid "safesend.panel.currentMonth"
msgstr "Mese corrente"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:30
msgid "safesend.panel.lastMonth"
msgstr "Mese scorso"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:31
msgid "safesend.panel.threeLastMonths"
msgstr "Ultimi 3 mesi"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:32
msgid "safesend.panel.sixLastMonths"
msgstr "Ultimi 6 mesi"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:321
msgid "snapshot.general.preblockSummary"
msgstr "Preblocco Mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:322
#: src/pages/DailyReport/useCards.tsx:340
msgid "snapshot.general.preblock.level"
msgstr "Liv. "

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:360
msgid "snapshot.general.blacklistSummary"
msgstr "Lista nera"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:379
msgid "snapshot.general.undelegatedSummary"
msgstr "Dominio non delegato"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:447
msgid "{nbPreblock, plural, one {# Mindbaz Preblock} other {# Mindbaz Preblocks}}"
msgstr "{nbPreblock, plural, one {# Preblocco Mindbaz} other {# Preblocchi Mindbaz}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:457
msgid "snapshot.general.noPreblock"
msgstr "Nessun preblocco Mindbaz attuale"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:465
msgid "{nbBlacklist, plural, one {# Blacklist} other {# Blacklists}}"
msgstr "{nbBlacklist, plural, one {# Lista nera} other {# Liste nere}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:471
msgid "snapshot.general.noBlacklist"
msgstr "Nessuna lista nera"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:479
msgid "{nbUndelegated, plural, one {# Undelegated domain} other {# Undelegated domains}}"
msgstr "{nbUndelegated, plural, one {# Dominio non delegato} other {# Domini non delegati}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:489
msgid "snapshot.general.noUndelegated"
msgstr "Tutti i tuoi domini sono delegati"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:497
msgid "snapshot.general.performance"
msgstr "Prestazioni per database"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:544
msgid "snapshot.performance.email"
msgstr "Email inviate per ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:566
msgid "snapshot.performance.deliverability"
msgstr "Deliverability per ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:585
msgid "{nbDeliverabilityAlert, plural, one {# deliverability alert} other {# deliverability alerts}}"
msgstr "{nbDeliverabilityAlert, plural, one {# avviso di deliverability} other {# avvisi di deliverability}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:595
msgid "snapshot.performance.noDeliverabilityAlert"
msgstr "Nessun avviso di deliverability attuale"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:603
msgid "snapshot.performance.performance"
msgstr "Prestazioni per ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:620
msgid "snapshot.performance.spamVol"
msgstr "Reclami spam (vol.)"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:623
#: src/pages/DailyReport/useCards.tsx:651
msgid "snapshot.performance.noResult"
msgstr "Nessun reclamo spam il {{date}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:648
msgid "snapshot.performance.spamPercent"
msgstr "Reclami spam (%)"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:154
msgid "features.goal"
msgstr "🎯 Il tuo obiettivo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:148
msgid "features.bafflingProblem"
msgstr "🤯 Il rompicapo"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:249
msgid "safesend.descriptionClickHere"
msgstr "clicca qui."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:325
msgid "safesend.databaseDetails"
msgstr "Dettagli per database"

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:159
msgid "features.description"
msgstr "Scopri le funzionalità di Rubixo basate sull'analisi di 16 miliardi di email instradate da Mindbaz ogni anno."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:88
msgid "feature.footer.learnMore"
msgstr "Scopri di più sugli audit email di Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:131
msgid "features.learnMore"
msgstr "Scopri di più"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:45
msgid "gone_page.link"
msgstr "Scopri di più su Dashboards"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:31
msgid "page_not_found.button"
msgstr "Accedi a Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:112
msgid "features.manageOffer"
msgstr "Gestisci il mio abbonamento"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:337
msgid "safesend.updateOffer"
msgstr "Modifica la mia offerta SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:351
msgid "safesend.popup.confirm"
msgstr "Modifica la mia offerta SafeSend"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:34
msgid "feature.footer.featureInProgress"
msgstr "Altre funzionalità sono in arrivo."

#. js-lingui-explicit-id
#: src/pages/Common/AccessDenied.tsx:38
msgid "oops"
msgstr "Ops! Non hai accesso a questa piattaforma."

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:31
msgid "gone_page.description1"
msgstr "I report Snapshot sono accessibili per <strong>7 giorni</strong> dopo la loro pubblicazione."

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:151
msgid "features.title"
msgstr "Risolvi il rompicapo della deliverability email con Rubixo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:40
msgid "feature.footer.follow"
msgstr "Resta aggiornato per non perderti nulla!"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:76
msgid "feature.footer.followEmailTraining"
msgstr "Segui un corso di formazione email con Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:20
msgid "page_not_found.title"
msgstr "Questa pagina non esiste"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:25
msgid "gone_page.title"
msgstr "Questo report Snapshot non è più disponibile"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:37
msgid "gone_page.description2"
msgstr "Per avere una vista completa dei tuoi invii, ti invitiamo a scoprire Dashboards."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:66
msgid "feature.footer.optimizeEmail"
msgstr "Vuoi ottimizzare il tuo email marketing?"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:24
msgid "page_not_found.description"
msgstr "Non abbiamo trovato la pagina che stavi cercando"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:105
msgid "features.freeAccess"
msgstr "Attualmente hai accesso gratuito"
